import type { HiringMatrix, Position } from "@/types";
import { MatrixCard } from "../card/MatrixCard";

interface Props {
  position: Position;
  matrices: HiringMatrix[];
  editingId: number | null;
  isSuperAdmin: boolean;
  onDeletePosition: (id: number) => void;
  onDeleteMatrix: (id: number) => void;
  onMatrixUpdated: () => void;
}

export function PositionMatrixGroup({
  position,
  matrices,
  editingId,
  isSuperAdmin,
  onDeletePosition,
  onDeleteMatrix,
  onMatrixUpdated,
}: Props) {
  return (
    <div className="rounded-card bg-white p-5 shadow-card my-2">
      <div className="flex items-start justify-between">
        <div>
          <h3 className="text-[20px] font-semibold leading-tight tracking-[-0.18px] text-near-black">
            {position.title}
          </h3>
          {isSuperAdmin && position.org_name && (
            <span className="mt-1 inline-flex items-center gap-1 rounded-btn bg-indigo-50 px-2.5 py-0.5 text-xs font-medium text-indigo-700">
              <svg
                className="h-3 w-3 shrink-0"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
                />
              </svg>
              {position.org_name}
            </span>
          )}
          {position.description && (
            <p className="mt-0.5 text-sm text-text-secondary">{position.description}</p>
          )}
        </div>
        <button
          onClick={() => onDeletePosition(position.id)}
          className="text-xs text-text-secondary transition-colors hover:text-error-text"
        >
          Delete position
        </button>
      </div>

      {matrices.length === 0 ? (
        <p className="mt-3 text-sm text-text-secondary">No matrices yet for this position.</p>
      ) : (
        <div className="mt-4 space-y-4">
          {matrices.map((m) => (
            <MatrixCard
              key={m.id}
              matrix={m}
              onDelete={onDeleteMatrix}
              onUpdated={onMatrixUpdated}
              defaultOpen={editingId === m.id}
            />
          ))}
        </div>
      )}
    </div>
  );
}
